/**
 * Tools 配置 - messages
 * 自动从 tools.ts 拆分生成
 */

export default {
    zh: {
        errorUnsupportedImageFormat: '请上传支持的图片格式（JPEG、PNG、WEBP）',
        errorImageSizeExceeded: '图片文件不能超过10MB',
        errorUnsupportedVideoFormat: '请上传支持的视频格式',
        errorVideoSizeExceeded: '视频文件不能超过500MB',
        errorVideoSizeExceededCustom: '视频文件不能超过{size}MB',
        errorUnsupportedAudioFormat: '请上传支持的音频格式',
        errorAudioSizeExceeded: '音频文件不能超过50MB',
        errorEnterVideoLink: '请输入视频链接',
        errorInvalidVideoLink: '请输入有效的视频链接',
        errorUploadVideoFirst: '请先上传视频',
        errorUploadVideoAndAudio: '请先上传视频和音频',
        errorUploadVideoAndFace: '请先上传视频和目标人脸',
        errorSelectVoiceAndText: '请选择声线并输入文本',
        errorSelectWatermarkArea: '请先框选水印区域',
        errorUploadVideoOrLink: '请先上传视频或输入视频链接',
        errorGetVoiceList: '获取声线列表失败',
        errorNoPreviewAudio: '该声线暂无预览音频',
        errorPlayFailed: '播放失败，请重试',
        errorVoicePreviewFailed: '声线预览播放失败',
        errorUploadVideoAndPrompt: '请先上传视频并输入提示词',
        errorVideoDurationTooShort: '上传视频长度需大于2秒',
        errorVideoDurationTooLong: '视频时长不能超过30秒',
        errorOutputResolutionTooLow: '输出分辨率不能低于原视频分辨率',
        errorOutputResolutionAutoAdjusted: '已自动将输出分辨率调整为 {resolution}',
        successImageUploaded: '图片上传成功',
        successVideoUploaded: '视频上传成功',
        successAudioUploaded: '音频上传成功',
        successTranslationComplete: '翻译完成！',
        successVideoLinkAdded: '视频链接已添加',
        successSelectionSaved: '选区已保存',
        successAudioGenerated: '音频生成成功！',
        successAudioDownloaded: '音频下载成功',
        successFaceSwapComplete: '视频换脸完成！',
        successLipSyncComplete: '视频对口型完成！',
        successWatermarkRemovalComplete: '开始处理视频去水印',
        successImageDownloaded: '图片下载成功',
        successVideoDownloaded: '视频下载成功',
        warningImageUploading: '图片上传中，请稍候...',
        warningFileUploading: '文件上传中，请稍候...',
        warningNoResult: '未获取到翻译结果',
        warningNoResultVideo: '未获取到结果视频',
        warningSelectionExists: '该选区已存在',
        warningNoAudioUrl: '未获取到音频地址',
        infoStartTranslation: '开始处理翻译...',
        infoStartWatermarkRemoval: '开始处理去水印...',
        infoStartFaceSwap: '开始处理换脸...',
        infoStartLipSync: '开始处理对口型...',
        infoGeneratingAudio: '正在生成音频...',
        failedUpload: '上传失败，请重试',
        failedImageUpload: '图片上传失败，请重试',
        failedVideoUpload: '视频上传失败，请重试',
        failedAudioUpload: '音频上传失败，请重试',
        failedTranslation: '翻译失败，请重试',
        failedGetResult: '获取结果失败',
        failedSubmit: '提交失败',
        failedFaceSwap: '换脸失败，请重试',
        failedLipSync: '对口型失败，请重试',
        failedWatermarkRemoval: '去水印失败，请重试',
        failedAudioGeneration: '音频生成失败，请重试',
        failedAudioDownload: '音频下载失败，请重试',
        failedImageDownload: '图片下载失败，请重试',
        failedVideoDownload: '视频下载失败，请重试',
        failedWithReason: '失败：',
        errorUploadVideoAndStyle: '请上传视频并选择风格',
        successVideoToAnimeComplete: '视频动漫化完成！',
        failedVideoToAnime: '视频动漫化失败',
    },
    en: {
        errorUnsupportedImageFormat: 'Please upload supported image formats (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'Image file cannot exceed 10MB',
        errorUnsupportedVideoFormat: 'Please upload supported video formats',
        errorVideoSizeExceeded: 'Video file cannot exceed 500MB',
        errorVideoSizeExceededCustom: 'Video file cannot exceed {size}MB',
        errorUnsupportedAudioFormat: 'Please upload supported audio formats',
        errorAudioSizeExceeded: 'Audio file cannot exceed 50MB',
        errorEnterVideoLink: 'Please enter video link',
        errorInvalidVideoLink: 'Please enter a valid video link',
        errorUploadVideoFirst: 'Please upload video first',
        errorUploadVideoAndAudio: 'Please upload video and audio first',
        errorUploadVideoAndFace: 'Please upload video and target face first',
        errorSelectVoiceAndText: 'Please select a voice and enter text',
        errorSelectWatermarkArea: 'Please select watermark area first',
        errorUploadVideoOrLink: 'Please upload video or enter video link',
        errorGetVoiceList: 'Failed to get voice list',
        errorNoPreviewAudio: 'This voice has no preview audio',
        errorPlayFailed: 'Playback failed, please try again',
        errorVoicePreviewFailed: 'Voice preview playback failed',
        errorUploadVideoAndPrompt: 'Please upload video and enter prompt first',
        errorVideoDurationTooShort: 'Video duration must be longer than 2 seconds',
        errorVideoDurationTooLong: 'Video duration cannot exceed 30 seconds',
        errorOutputResolutionTooLow: 'Output resolution cannot be lower than the source video resolution',
        errorOutputResolutionAutoAdjusted: 'Output resolution has been auto-adjusted to {resolution}',
        successImageUploaded: 'Image uploaded successfully',
        successVideoUploaded: 'Video uploaded successfully',
        successAudioUploaded: 'Audio uploaded successfully',
        successTranslationComplete: 'Translation complete!',
        successVideoLinkAdded: 'Video link added successfully',
        successSelectionSaved: 'Selection saved successfully',
        successAudioGenerated: 'Audio generated successfully!',
        successAudioDownloaded: 'Audio downloaded successfully',
        successFaceSwapComplete: 'Face swap complete!',
        successLipSyncComplete: 'Lip sync complete!',
        successWatermarkRemovalComplete: 'Starting video watermark removal',
        successImageDownloaded: 'Image downloaded successfully',
        successVideoDownloaded: 'Video downloaded successfully',
        warningImageUploading: 'Image uploading, please wait...',
        warningFileUploading: 'File uploading, please wait...',
        warningNoResult: 'No translation result obtained',
        warningNoResultVideo: 'No result video obtained',
        warningSelectionExists: 'This selection already exists',
        warningNoAudioUrl: 'No audio URL obtained',
        infoStartTranslation: 'Starting translation processing...',
        infoStartWatermarkRemoval: 'Starting watermark removal processing...',
        infoStartFaceSwap: 'Starting face swap processing...',
        infoStartLipSync: 'Starting lip sync processing...',
        infoGeneratingAudio: 'Generating audio...',
        failedUpload: 'Upload failed, please try again',
        failedImageUpload: 'Image upload failed, please try again',
        failedVideoUpload: 'Video upload failed, please try again',
        failedAudioUpload: 'Audio upload failed, please try again',
        failedTranslation: 'Translation failed, please try again',
        failedGetResult: 'Failed to get result',
        failedSubmit: 'Submit failed',
        failedFaceSwap: 'Face swap failed, please try again',
        failedLipSync: 'Lip sync failed, please try again',
        failedWatermarkRemoval: 'Watermark removal failed, please try again',
        failedAudioGeneration: 'Audio generation failed, please try again',
        failedAudioDownload: 'Audio download failed, please try again',
        failedImageDownload: 'Image download failed, please try again',
        failedVideoDownload: 'Video download failed, please try again',
        failedWithReason: 'Failed: ',
        errorUploadVideoAndStyle: 'Please upload video and select style',
        successVideoToAnimeComplete: 'Video anime conversion completed!',
        failedVideoToAnime: 'Video anime conversion failed',
    },
    ja: {
        errorUnsupportedImageFormat: '対応している画像形式をアップロードしてください（JPEG、PNG、WEBP）',
        errorImageSizeExceeded: '画像ファイルは10MBを超えることはできません',
        errorUnsupportedVideoFormat: '対応している動画形式をアップロードしてください',
        errorVideoSizeExceeded: '動画ファイルは500MBを超えることはできません',
        errorVideoSizeExceededCustom: '動画ファイルは{size}MBを超えることはできません',
        errorUnsupportedAudioFormat: '対応している音声形式をアップロードしてください',
        errorAudioSizeExceeded: '音声ファイルは50MBを超えることはできません',
        errorEnterVideoLink: '動画リンクを入力してください',
        errorInvalidVideoLink: '有効な動画リンクを入力してください',
        errorUploadVideoFirst: '最初に動画をアップロードしてください',
        errorUploadVideoAndAudio: '最初に動画と音声をアップロードしてください',
        errorUploadVideoAndFace: '最初に動画とターゲット顔をアップロードしてください',
        errorSelectVoiceAndText: '声を選択してテキストを入力してください',
        errorSelectWatermarkArea: '最初に透かしエリアを選択してください',
        errorUploadVideoOrLink: '最初に動画をアップロードまたは動画リンクを入力してください',
        errorGetVoiceList: '声リストの取得に失敗しました',
        errorNoPreviewAudio: 'この声にはプレビュー音声がありません',
        errorPlayFailed: '再生に失敗しました、もう一度お試しください',
        errorVoicePreviewFailed: '声プレビューの再生に失敗しました',
        errorUploadVideoAndPrompt: '最初に動画をアップロードしてプロンプトを入力してください',
        errorVideoDurationTooShort: 'ビデオの長さは2秒以上である必要があります',
        errorVideoDurationTooLong: 'ビデオの長さは30秒を超えることはできません',
        errorOutputResolutionTooLow: '出力解像度は元の動画の解像度より低くできません',
        errorOutputResolutionAutoAdjusted: '出力解像度を {resolution} に自動調整しました',
        successImageUploaded: '画像が正常にアップロードされました',
        successVideoUploaded: '動画が正常にアップロードされました',
        successAudioUploaded: '音声が正常にアップロードされました',
        successTranslationComplete: '翻訳完了！',
        successVideoLinkAdded: '動画リンクが正常に追加されました',
        successSelectionSaved: '選択が正常に保存されました',
        successAudioGenerated: '音声が正常に生成されました！',
        successAudioDownloaded: 'オーディオのダウンロードが成功しました',
        successFaceSwapComplete: '顔交換完了！',
        successLipSyncComplete: 'リップシンク完了！',
        successWatermarkRemovalComplete: '動画の透かし除去を開始します',
        successImageDownloaded: '画像が正常にダウンロードされました',
        successVideoDownloaded: '動画が正常にダウンロードされました',
        warningImageUploading: '画像をアップロード中、お待ちください...',
        warningFileUploading: 'ファイルをアップロード中、お待ちください...',
        warningNoResult: '翻訳結果が得られませんでした',
        warningNoResultVideo: '結果動画が得られませんでした',
        warningSelectionExists: 'この選択は既に存在します',
        warningNoAudioUrl: '音声URLが得られませんでした',
        infoStartTranslation: '翻訳処理を開始しています...',
        infoStartWatermarkRemoval: '透かし除去処理を開始しています...',
        infoStartFaceSwap: '顔交換処理を開始しています...',
        infoStartLipSync: 'リップシンク処理を開始しています...',
        infoGeneratingAudio: '音声を生成中...',
        failedUpload: 'アップロードに失敗しました、もう一度お試しください',
        failedImageUpload: '画像のアップロードに失敗しました、もう一度お試しください',
        failedVideoUpload: '動画のアップロードに失敗しました、もう一度お試しください',
        failedAudioUpload: '音声のアップロードに失敗しました、もう一度お試しください',
        failedTranslation: '翻訳に失敗しました、もう一度お試しください',
        failedGetResult: '結果の取得に失敗しました',
        failedSubmit: '送信に失敗しました',
        failedFaceSwap: '顔交換に失敗しました、もう一度お試しください',
        failedLipSync: 'リップシンクに失敗しました、もう一度お試しください',
        failedWatermarkRemoval: '透かし除去に失敗しました、もう一度お試しください',
        failedAudioGeneration: '音声生成に失敗しました、もう一度お試しください',
        failedAudioDownload: 'オーディオのダウンロードに失敗しました。もう一度お試しください',
        failedImageDownload: '画像のダウンロードに失敗しました、もう一度お試しください',
        failedVideoDownload: '動画のダウンロードに失敗しました、もう一度お試しください',
        failedWithReason: '失敗：',
        errorUploadVideoAndStyle: '動画をアップロードし、スタイルを選択してください',
        successVideoToAnimeComplete: '動画アニメ化が完了しました！',
        failedVideoToAnime: '動画アニメ化に失敗しました',
    },
    ko: {
        errorUnsupportedImageFormat: '지원되는 이미지 형식을 업로드하세요 (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: '이미지 파일은 10MB를 초과할 수 없습니다',
        errorUnsupportedVideoFormat: '지원되는 비디오 형식을 업로드하세요',
        errorVideoSizeExceeded: '비디오 파일은 500MB를 초과할 수 없습니다',
        errorVideoSizeExceededCustom: '비디오 파일은 {size}MB를 초과할 수 없습니다',
        errorUnsupportedAudioFormat: '지원되는 오디오 형식을 업로드하세요',
        errorAudioSizeExceeded: '오디오 파일은 50MB를 초과할 수 없습니다',
        errorEnterVideoLink: '비디오 링크를 입력하세요',
        errorInvalidVideoLink: '유효한 비디오 링크를 입력하세요',
        errorUploadVideoFirst: '먼저 비디오를 업로드하세요',
        errorUploadVideoAndAudio: '먼저 비디오와 오디오를 업로드하세요',
        errorUploadVideoAndFace: '먼저 비디오와 대상 얼굴을 업로드하세요',
        errorSelectVoiceAndText: '음성을 선택하고 텍스트를 입력하세요',
        errorSelectWatermarkArea: '먼저 워터마크 영역을 선택하세요',
        errorUploadVideoOrLink: '먼저 비디오를 업로드하거나 비디오 링크를 입력하세요',
        errorGetVoiceList: '음성 목록을 가져오는데 실패했습니다',
        errorNoPreviewAudio: '이 음성에는 미리보기 오디오가 없습니다',
        errorPlayFailed: '재생에 실패했습니다, 다시 시도하세요',
        errorVoicePreviewFailed: '음성 미리보기 재생에 실패했습니다',
        errorUploadVideoAndPrompt: '먼저 비디오를 업로드하고 프롬프트를 입력하세요',
        errorVideoDurationTooShort: '비디오 길이는 2초 이상이어야 합니다',
        errorVideoDurationTooLong: '비디오 길이는 30초를 초과할 수 없습니다',
        errorOutputResolutionTooLow: '출력 해상도는 원본 비디오 해상도보다 낮을 수 없습니다',
        errorOutputResolutionAutoAdjusted: '출력 해상도가 {resolution}로 자동 조정되었습니다',
        successImageUploaded: '이미지가 성공적으로 업로드되었습니다',
        successVideoUploaded: '비디오가 성공적으로 업로드되었습니다',
        successAudioUploaded: '오디오가 성공적으로 업로드되었습니다',
        successTranslationComplete: '번역 완료!',
        successVideoLinkAdded: '비디오 링크가 성공적으로 추가되었습니다',
        successSelectionSaved: '선택이 성공적으로 저장되었습니다',
        successAudioGenerated: '오디오가 성공적으로 생성되었습니다!',
        successAudioDownloaded: '오디오 다운로드 성공',
        successFaceSwapComplete: '얼굴 바꾸기 완료!',
        successLipSyncComplete: '립싱크 완료!',
        successWatermarkRemovalComplete: '비디오 워터마크 제거를 시작합니다',
        successImageDownloaded: '이미지가 성공적으로 다운로드되었습니다',
        successVideoDownloaded: '비디오가 성공적으로 다운로드되었습니다',
        warningImageUploading: '이미지 업로드 중, 잠시 기다려주세요...',
        warningFileUploading: '파일 업로드 중, 잠시 기다려주세요...',
        warningNoResult: '번역 결과를 얻지 못했습니다',
        warningNoResultVideo: '결과 비디오를 얻지 못했습니다',
        warningSelectionExists: '이 선택은 이미 존재합니다',
        warningNoAudioUrl: '오디오 URL을 얻지 못했습니다',
        infoStartTranslation: '번역 처리를 시작합니다...',
        infoStartWatermarkRemoval: '워터마크 제거 처리를 시작합니다...',
        infoStartFaceSwap: '얼굴 바꾸기 처리를 시작합니다...',
        infoStartLipSync: '립싱크 처리를 시작합니다...',
        infoGeneratingAudio: '오디오 생성 중...',
        failedUpload: '업로드 실패, 다시 시도하세요',
        failedImageUpload: '이미지 업로드 실패, 다시 시도하세요',
        failedVideoUpload: '비디오 업로드 실패, 다시 시도하세요',
        failedAudioUpload: '오디오 업로드 실패, 다시 시도하세요',
        failedTranslation: '번역 실패, 다시 시도하세요',
        failedGetResult: '결과 가져오기 실패',
        failedSubmit: '제출 실패',
        failedFaceSwap: '얼굴 바꾸기 실패, 다시 시도하세요',
        failedLipSync: '립싱크 실패, 다시 시도하세요',
        failedWatermarkRemoval: '워터마크 제거 실패, 다시 시도하세요',
        failedAudioGeneration: '오디오 생성 실패, 다시 시도하세요',
        failedAudioDownload: '오디오 다운로드 실패, 다시 시도해주세요',
        failedImageDownload: '이미지 다운로드 실패, 다시 시도하세요',
        failedVideoDownload: '비디오 다운로드 실패, 다시 시도하세요',
        failedWithReason: '실패: ',
        errorUploadVideoAndStyle: '비디오를 업로드하고 스타일을 선택하세요',
        successVideoToAnimeComplete: '비디오 애니메이션 변환이 완료되었습니다!',
        failedVideoToAnime: '비디오 애니메이션 변환 실패',
    },
    tw: {
        errorUnsupportedImageFormat: '请上传支援的圖片格式（JPEG、PNG、WEBP）',
        errorImageSizeExceeded: '圖片文件不能超过10MB',
        errorUnsupportedVideoFormat: '请上传支援的影片格式',
        errorVideoSizeExceeded: '影片文件不能超过500MB',
        errorVideoSizeExceededCustom: '影片文件不能超过{size}MB',
        errorUnsupportedAudioFormat: '请上传支援的音频格式',
        errorAudioSizeExceeded: '音频文件不能超过50MB',
        errorEnterVideoLink: '請輸入影片链接',
        errorInvalidVideoLink: '請輸入有效的影片链接',
        errorUploadVideoFirst: '请先上传影片',
        errorUploadVideoAndAudio: '请先上传影片和音频',
        errorUploadVideoAndFace: '请先上传影片和目标人臉',
        errorSelectVoiceAndText: '请选择声线并输入文本',
        errorSelectWatermarkArea: '请先框选浮水印区域',
        errorUploadVideoOrLink: '请先上传影片或输入影片链接',
        errorGetVoiceList: '获取声线列表失败',
        errorNoPreviewAudio: '该声线暂无预览音频',
        errorPlayFailed: '播放失败，请重试',
        errorVoicePreviewFailed: '声线预览播放失败',
        errorUploadVideoAndPrompt: '请先上传影片并输入提示語',
        errorVideoDurationTooShort: '上传影片长度需大于2秒',
        errorVideoDurationTooLong: '影片时长不能超过30秒',
        errorOutputResolutionTooLow: '輸出解析度不能低于原影片解析度',
        errorOutputResolutionAutoAdjusted: '已自动将輸出解析度调整为 {resolution}',
        successImageUploaded: '圖片上传成功',
        successVideoUploaded: '影片上传成功',
        successAudioUploaded: '音频上传成功',
        successTranslationComplete: '翻译完成！',
        successVideoLinkAdded: '影片链接已添加',
        successSelectionSaved: '选区已保存',
        successAudioGenerated: '音频產生成功！',
        successAudioDownloaded: '音频下载成功',
        successFaceSwapComplete: '影片换脸完成！',
        successLipSyncComplete: '影片对口型完成！',
        successWatermarkRemovalComplete: '开始处理影片去浮水印',
        successImageDownloaded: '圖片下载成功',
        successVideoDownloaded: '影片下载成功',
        warningImageUploading: '圖片上传中，请稍候...',
        warningFileUploading: '文件上传中，请稍候...',
        warningNoResult: '未获取到翻译结果',
        warningNoResultVideo: '未获取到结果影片',
        warningSelectionExists: '该选区已存在',
        warningNoAudioUrl: '未获取到音频地址',
        infoStartTranslation: '開始處理翻譯...',
        infoStartWatermarkRemoval: '開始處理去浮水印...',
        infoStartFaceSwap: '開始處理換臉...',
        infoStartLipSync: '開始處理對口型...',
        infoGeneratingAudio: '正在產生音訊...',
        failedUpload: '上傳失敗，請重試',
        failedImageUpload: '圖片上傳失敗，請重試',
        failedVideoUpload: '影片上傳失敗，請重試',
        failedAudioUpload: '音訊上傳失敗，請重試',
        failedTranslation: '翻譯失敗，請重試',
        failedGetResult: '獲取結果失敗',
        failedSubmit: '提交失敗',
        failedFaceSwap: '換臉失敗，請重試',
        failedLipSync: '對口型失敗，請重試',
        failedWatermarkRemoval: '去浮水印失敗，請重試',
        failedAudioGeneration: '音訊產生失敗，請重試',
        failedAudioDownload: '音訊下載失敗，請重試',
        failedImageDownload: '圖片下載失敗，請重試',
        failedVideoDownload: '影片下載失敗，請重試',
        failedWithReason: '失敗：',
        errorUploadVideoAndStyle: '请上传影片并选择風格',
        successVideoToAnimeComplete: '影片動漫化完成！',
        failedVideoToAnime: '影片動漫化失败',
    },
    pl: {
        errorUnsupportedImageFormat: 'Prześlij obsługiwane formaty obrazu (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'Plik obrazu nie może przekroczyć 10MB',
        errorUnsupportedVideoFormat: 'Prześlij obsługiwane formaty wideo',
        errorVideoSizeExceeded: 'Plik wideo nie może przekroczyć 500MB',
        errorVideoSizeExceededCustom: 'Plik wideo nie może przekroczyć {size}MB',
        errorUnsupportedAudioFormat: 'Prześlij obsługiwane formaty audio',
        errorAudioSizeExceeded: 'Plik audio nie może przekroczyć 50MB',
        errorEnterVideoLink: 'Wpisz link do wideo',
        errorInvalidVideoLink: 'Wpisz prawidłowy link do wideo',
        errorUploadVideoFirst: 'Najpierw prześlij wideo',
        errorUploadVideoAndAudio: 'Najpierw prześlij wideo i audio',
        errorUploadVideoAndFace: 'Najpierw prześlij wideo i docelową twarz',
        errorSelectVoiceAndText: 'Wybierz głos i wpisz tekst',
        errorSelectWatermarkArea: 'Najpierw wybierz obszar znaku wodnego',
        errorUploadVideoOrLink: 'Najpierw prześlij wideo lub wpisz link',
        errorGetVoiceList: 'Nie udało się pobrać listy głosów',
        errorNoPreviewAudio: 'Ten głos nie ma podglądu audio',
        errorPlayFailed: 'Odtwarzanie nie powiodło się, spróbuj ponownie',
        errorVoicePreviewFailed: 'Podgląd głosu nie powiódł się',
        errorUploadVideoAndPrompt: 'Prześlij wideo i wpisz prompt',
        errorVideoDurationTooShort: 'Długość wideo musi być większa niż 2 sekundy',
        errorVideoDurationTooLong: 'Długość wideo nie może przekroczyć 30 sekund',
        errorOutputResolutionTooLow: 'Rozdzielczość wyjściowa nie może być niższa niż rozdzielczość źródłowa',
        errorOutputResolutionAutoAdjusted: 'Rozdzielczość wyjściowa została automatycznie dostosowana do {resolution}',
        successImageUploaded: 'Obraz przesłany',
        successVideoUploaded: 'Wideo przesłane',
        successAudioUploaded: 'Audio przesłane',
        successTranslationComplete: 'Tłumaczenie zakończone!',
        successVideoLinkAdded: 'Link do wideo dodany',
        successSelectionSaved: 'Wybór zapisany',
        successAudioGenerated: 'Audio wygenerowane!',
        successAudioDownloaded: 'Audio pobrane',
        successFaceSwapComplete: 'Podmiana twarzy zakończona!',
        successLipSyncComplete: 'Synchronizacja ust zakończona!',
        successWatermarkRemovalComplete: 'Rozpoczęto usuwanie znaku wodnego z wideo',
        successImageDownloaded: 'Obraz pobrany',
        successVideoDownloaded: 'Wideo pobrane',
        warningImageUploading: 'Przesyłanie obrazu, proszę czekać...',
        warningFileUploading: 'Przesyłanie pliku, proszę czekać...',
        warningNoResult: 'Nie otrzymano wyniku tłumaczenia',
        warningNoResultVideo: 'Nie otrzymano wideo wynikowego',
        warningSelectionExists: 'To zaznaczenie już istnieje',
        warningNoAudioUrl: 'Nie uzyskano adresu URL audio',
        infoStartTranslation: 'Rozpoczynanie przetwarzania tłumaczenia...',
        infoStartWatermarkRemoval: 'Rozpoczynanie przetwarzania usuwania znaku wodnego...',
        infoStartFaceSwap: 'Rozpoczynanie przetwarzania podmiany twarzy...',
        infoStartLipSync: 'Rozpoczynanie przetwarzania synchronizacji ust...',
        infoGeneratingAudio: 'Generowanie audio...',
        failedUpload: 'Przesyłanie nie powiodło się, spróbuj ponownie',
        failedImageUpload: 'Przesyłanie obrazu nie powiodło się, spróbuj ponownie',
        failedVideoUpload: 'Przesyłanie wideo nie powiodło się, spróbuj ponownie',
        failedAudioUpload: 'Przesyłanie audio nie powiodło się, spróbuj ponownie',
        failedTranslation: 'Tłumaczenie nie powiodło się, spróbuj ponownie',
        failedGetResult: 'Nie udało się pobrać wyniku',
        failedSubmit: 'Wysłanie nie powiodło się',
        failedFaceSwap: 'Podmiana twarzy nie powiodła się, spróbuj ponownie',
        failedLipSync: 'Synchronizacja ust nie powiodła się, spróbuj ponownie',
        failedWatermarkRemoval: 'Usuwanie znaku wodnego nie powiodło się, spróbuj ponownie',
        failedAudioGeneration: 'Generowanie audio nie powiodło się, spróbuj ponownie',
        failedAudioDownload: 'Pobieranie audio nie powiodło się, spróbuj ponownie',
        failedImageDownload: 'Pobieranie obrazu nie powiodło się, spróbuj ponownie',
        failedVideoDownload: 'Pobieranie wideo nie powiodło się, spróbuj ponownie',
        failedWithReason: 'Niepowodzenie: ',
        errorUploadVideoAndStyle: 'Prześlij wideo i wybierz styl',
        successVideoToAnimeComplete: 'Konwersja wideo na anime zakończona!',
        failedVideoToAnime: 'Konwersja wideo na anime nie powiodła się',
    },
    es: {
        errorUnsupportedImageFormat: 'Por favor sube formatos de imagen compatibles (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'El archivo de imagen no puede superar 10MB',
        errorUnsupportedVideoFormat: 'Por favor sube formatos de video compatibles',
        errorVideoSizeExceeded: 'El archivo de video no puede superar 500MB',
        errorVideoSizeExceededCustom: 'El archivo de video no puede superar {size}MB',
        errorUnsupportedAudioFormat: 'Por favor sube formatos de audio compatibles',
        errorAudioSizeExceeded: 'El archivo de audio no puede superar 50MB',
        errorEnterVideoLink: 'Por favor ingresa el enlace del video',
        errorInvalidVideoLink: 'Por favor ingresa un enlace de video válido',
        errorUploadVideoFirst: 'Por favor sube primero el video',
        errorUploadVideoAndAudio: 'Por favor sube primero el video y el audio',
        errorUploadVideoAndFace: 'Por favor sube primero el video y el rostro objetivo',
        errorSelectVoiceAndText: 'Por favor selecciona la voz e ingresa el texto',
        errorSelectWatermarkArea: 'Por favor selecciona primero el área de marca de agua',
        errorUploadVideoOrLink: 'Por favor sube el video o ingresa el enlace del video',
        errorGetVoiceList: 'No se pudo obtener la lista de voces',
        errorNoPreviewAudio: 'Esta voz no tiene audio de vista previa',
        errorPlayFailed: 'La reproducción falló, inténtalo de nuevo',
        errorVoicePreviewFailed: 'Falló la reproducción de vista previa de la voz',
        errorUploadVideoAndPrompt: 'Por favor sube el video e ingresa el prompt',
        errorVideoDurationTooShort: 'La duración del video debe ser mayor a 2 segundos',
        errorVideoDurationTooLong: 'La duración del video no puede superar los 30 segundos',
        errorOutputResolutionTooLow: 'La resolución de salida no puede ser inferior a la del video original',
        errorOutputResolutionAutoAdjusted: 'La resolución de salida se ha ajustado automáticamente a {resolution}',
        successImageUploaded: 'Imagen subida correctamente',
        successVideoUploaded: 'Video subido correctamente',
        successAudioUploaded: 'Audio subido correctamente',
        successTranslationComplete: '¡Traducción completada!',
        successVideoLinkAdded: 'Enlace de video añadido',
        successSelectionSaved: 'Selección guardada',
        successAudioGenerated: '¡Audio generado!',
        successAudioDownloaded: 'Audio descargado',
        successFaceSwapComplete: 'Intercambio de rostro completado',
        successLipSyncComplete: 'Sincronización labial completada',
        successWatermarkRemovalComplete: 'Iniciando eliminación de marca de agua de video',
        successImageDownloaded: 'Imagen descargada',
        successVideoDownloaded: 'Video descargado',
        warningImageUploading: 'Subiendo imagen, por favor espera...',
        warningFileUploading: 'Subiendo archivo, por favor espera...',
        warningNoResult: 'No se recibió resultado de traducción',
        warningNoResultVideo: 'No se recibió video de resultado',
        warningSelectionExists: 'Esta selección ya existe',
        warningNoAudioUrl: 'No se recibió URL de audio',
        infoStartTranslation: 'Iniciando procesamiento de traducción...',
        infoStartWatermarkRemoval: 'Iniciando procesamiento de eliminación de marca de agua...',
        infoStartFaceSwap: 'Iniciando procesamiento de intercambio de rostro...',
        infoStartLipSync: 'Iniciando procesamiento de sincronización labial...',
        infoGeneratingAudio: 'Generando audio...',
        failedUpload: 'La subida falló, inténtalo de nuevo',
        failedImageUpload: 'La subida de imagen falló, inténtalo de nuevo',
        failedVideoUpload: 'La subida de video falló, inténtalo de nuevo',
        failedAudioUpload: 'La subida de audio falló, inténtalo de nuevo',
        failedTranslation: 'La traducción falló, inténtalo de nuevo',
        failedGetResult: 'No se pudo obtener el resultado',
        failedSubmit: 'El envío falló',
        failedFaceSwap: 'El intercambio de rostros falló, inténtalo de nuevo',
        failedLipSync: 'La sincronización labial falló, inténtalo de nuevo',
        failedWatermarkRemoval: 'La eliminación de marca de agua falló, inténtalo de nuevo',
        failedAudioGeneration: 'La generación de audio falló, inténtalo de nuevo',
        failedAudioDownload: 'La descarga de audio falló, inténtalo de nuevo',
        failedImageDownload: 'La descarga de imagen falló, inténtalo de nuevo',
        failedVideoDownload: 'La descarga de video falló, inténtalo de nuevo',
        failedWithReason: 'Falló: ',
        errorUploadVideoAndStyle: 'Por favor sube un video y selecciona un estilo',
        successVideoToAnimeComplete: '¡Conversión de video a anime completada!',
        failedVideoToAnime: 'Error en la conversión de video a anime',
    },
    fr: {
        errorUnsupportedImageFormat: 'Veuillez télécharger des formats d’image pris en charge (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'Le fichier image ne peut pas dépasser 10 Mo',
        errorUnsupportedVideoFormat: 'Veuillez télécharger des formats vidéo pris en charge',
        errorVideoSizeExceeded: 'Le fichier vidéo ne peut pas dépasser 500 Mo',
        errorVideoSizeExceededCustom: 'Le fichier vidéo ne peut pas dépasser {size}MB',
        errorUnsupportedAudioFormat: 'Veuillez télécharger des formats audio pris en charge',
        errorAudioSizeExceeded: 'Le fichier audio ne peut pas dépasser 50 Mo',
        errorEnterVideoLink: 'Veuillez saisir le lien vidéo',
        errorInvalidVideoLink: 'Veuillez saisir un lien vidéo valide',
        errorUploadVideoFirst: 'Veuillez d’abord télécharger la vidéo',
        errorUploadVideoAndAudio: 'Veuillez d’abord télécharger la vidéo et l’audio',
        errorUploadVideoAndFace: 'Veuillez d’abord télécharger la vidéo et le visage cible',
        errorSelectVoiceAndText: 'Veuillez sélectionner une voix et saisir le texte',
        errorSelectWatermarkArea: 'Veuillez sélectionner d’abord la zone du filigrane',
        errorUploadVideoOrLink: 'Veuillez télécharger la vidéo ou saisir le lien vidéo',
        errorGetVoiceList: 'Échec de la récupération de la liste des voix',
        errorNoPreviewAudio: 'Cette voix n’a pas d’audio d’aperçu',
        errorPlayFailed: 'Échec de la lecture, veuillez réessayer',
        errorVoicePreviewFailed: 'Échec de la lecture de l’aperçu de la voix',
        errorUploadVideoAndPrompt: 'Veuillez télécharger la vidéo et saisir le prompt',
        errorVideoDurationTooShort: 'La durée de la vidéo doit être supérieure à 2 secondes',
        errorVideoDurationTooLong: 'La durée de la vidéo ne peut pas dépasser 30 secondes',
        errorOutputResolutionTooLow: `La résolution de sortie ne peut pas être inférieure à celle de la vidéo d'origine`,
        errorOutputResolutionAutoAdjusted: 'La résolution de sortie a été ajustée automatiquement à {resolution}',
        successImageUploaded: 'Image téléversée',
        successVideoUploaded: 'Vidéo téléversée',
        successAudioUploaded: 'Audio téléversé',
        successTranslationComplete: 'Traduction terminée !',
        successVideoLinkAdded: 'Lien vidéo ajouté',
        successSelectionSaved: 'Sélection enregistrée',
        successAudioGenerated: 'Audio généré !',
        successAudioDownloaded: 'Audio téléchargé',
        successFaceSwapComplete: 'Échange de visage terminé !',
        successLipSyncComplete: 'Synchronisation labiale terminée !',
        successWatermarkRemovalComplete: 'Démarrage de la suppression du filigrane vidéo',
        successImageDownloaded: 'Image téléchargée',
        successVideoDownloaded: 'Vidéo téléchargée',
        warningImageUploading: 'Téléchargement de l’image, veuillez patienter...',
        warningFileUploading: 'Téléchargement du fichier, veuillez patienter...',
        warningNoResult: 'Aucun résultat de traduction reçu',
        warningNoResultVideo: 'Aucune vidéo de résultat reçue',
        warningSelectionExists: 'Cette sélection existe déjà',
        warningNoAudioUrl: 'Aucune URL audio reçue',
        infoStartTranslation: 'Démarrage du traitement de traduction...',
        infoStartWatermarkRemoval: 'Démarrage du traitement de suppression du filigrane...',
        infoStartFaceSwap: 'Démarrage du traitement d’échange de visage...',
        infoStartLipSync: 'Démarrage du traitement de synchronisation labiale...',
        infoGeneratingAudio: 'Génération de l’audio...',
        failedUpload: 'Échec du téléversement, veuillez réessayer',
        failedImageUpload: 'Échec du téléversement de l’image, veuillez réessayer',
        failedVideoUpload: 'Échec du téléversement de la vidéo, veuillez réessayer',
        failedAudioUpload: 'Échec du téléversement de l’audio, veuillez réessayer',
        failedTranslation: 'Échec de la traduction, veuillez réessayer',
        failedGetResult: 'Impossible d’obtenir le résultat',
        failedSubmit: 'Échec de l’envoi',
        failedFaceSwap: 'Échec de l’échange de visage, veuillez réessayer',
        failedLipSync: 'Échec de la synchronisation labiale, veuillez réessayer',
        failedWatermarkRemoval: 'Échec de la suppression du filigrane, veuillez réessayer',
        failedAudioGeneration: 'Échec de la génération audio, veuillez réessayer',
        failedAudioDownload: 'Échec du téléchargement audio, veuillez réessayer',
        failedImageDownload: 'Échec du téléchargement de l’image, veuillez réessayer',
        failedVideoDownload: 'Échec du téléchargement de la vidéo, veuillez réessayer',
        failedWithReason: 'Échec : ',
        errorUploadVideoAndStyle: 'Veuillez télécharger une vidéo et sélectionner un style',
        successVideoToAnimeComplete: 'Conversion vidéo en anime terminée !',
        failedVideoToAnime: 'Échec de la conversion vidéo en anime',
    },
    de: {
        errorUnsupportedImageFormat: 'Bitte laden Sie unterstützte Bildformate hoch (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'Die Bilddatei darf 10 MB nicht überschreiten',
        errorUnsupportedVideoFormat: 'Bitte laden Sie unterstützte Videoformate hoch',
        errorVideoSizeExceeded: 'Die Videodatei darf 500 MB nicht überschreiten',
        errorVideoSizeExceededCustom: 'Die Videodatei darf {size}MB nicht überschreiten',
        errorUnsupportedAudioFormat: 'Bitte laden Sie unterstützte Audioformate hoch',
        errorAudioSizeExceeded: 'Die Audiodatei darf 50 MB nicht überschreiten',
        errorEnterVideoLink: 'Bitte geben Sie den Videolink ein',
        errorInvalidVideoLink: 'Bitte geben Sie einen gültigen Videolink ein',
        errorUploadVideoFirst: 'Bitte laden Sie zuerst ein Video hoch',
        errorUploadVideoAndAudio: 'Bitte laden Sie zuerst Video und Audio hoch',
        errorUploadVideoAndFace: 'Bitte laden Sie zuerst Video und Zielgesicht hoch',
        errorSelectVoiceAndText: 'Bitte wählen Sie eine Stimme und geben Sie Text ein',
        errorSelectWatermarkArea: 'Bitte wählen Sie zuerst den Wasserzeichenbereich aus',
        errorUploadVideoOrLink: 'Bitte laden Sie ein Video hoch oder geben Sie einen Videolink ein',
        errorGetVoiceList: 'Stimmenliste konnte nicht abgerufen werden',
        errorNoPreviewAudio: 'Diese Stimme hat keine Vorschau-Audio',
        errorPlayFailed: 'Wiedergabe fehlgeschlagen, bitte versuchen Sie es erneut',
        errorVoicePreviewFailed: 'Stimmenvorschau-Wiedergabe fehlgeschlagen',
        errorUploadVideoAndPrompt: 'Bitte laden Sie ein Video hoch und geben Sie einen Prompt ein',
        errorVideoDurationTooShort: 'Die Videodauer muss größer als 2 Sekunden sein',
        errorVideoDurationTooLong: 'Die Videodauer darf 30 Sekunden nicht überschreiten',
        errorOutputResolutionTooLow: 'Die Ausgabeauflösung darf nicht niedriger als die Quellvideoauflösung sein',
        errorOutputResolutionAutoAdjusted: 'Die Ausgabeauflösung wurde automatisch auf {resolution} angepasst',
        successImageUploaded: 'Bild erfolgreich hochgeladen',
        successVideoUploaded: 'Video erfolgreich hochgeladen',
        successAudioUploaded: 'Audio erfolgreich hochgeladen',
        successTranslationComplete: 'Übersetzung abgeschlossen!',
        successVideoLinkAdded: 'Videolink erfolgreich hinzugefügt',
        successSelectionSaved: 'Auswahl erfolgreich gespeichert',
        successAudioGenerated: 'Audio erfolgreich generiert!',
        successAudioDownloaded: 'Audio erfolgreich heruntergeladen',
        successFaceSwapComplete: 'Gesichtstausch abgeschlossen!',
        successLipSyncComplete: 'Lippensynchronisation abgeschlossen!',
        successWatermarkRemovalComplete: 'Video-Wasserzeichenentfernung wird gestartet',
        successImageDownloaded: 'Bild erfolgreich heruntergeladen',
        successVideoDownloaded: 'Video erfolgreich heruntergeladen',
        warningImageUploading: 'Bild wird hochgeladen, bitte warten...',
        warningFileUploading: 'Datei wird hochgeladen, bitte warten...',
        warningNoResult: 'Kein Übersetzungsergebnis erhalten',
        warningNoResultVideo: 'Kein Ergebnisvideo erhalten',
        warningSelectionExists: 'Diese Auswahl existiert bereits',
        warningNoAudioUrl: 'Keine Audio-URL erhalten',
        infoStartTranslation: 'Übersetzungsverarbeitung wird gestartet...',
        infoStartWatermarkRemoval: 'Wasserzeichenentfernung wird gestartet...',
        infoStartFaceSwap: 'Gesichtstausch wird gestartet...',
        infoStartLipSync: 'Lippensynchronisation wird gestartet...',
        infoGeneratingAudio: 'Audio wird generiert...',
        failedUpload: 'Upload fehlgeschlagen, bitte versuchen Sie es erneut',
        failedImageUpload: 'Bildupload fehlgeschlagen, bitte versuchen Sie es erneut',
        failedVideoUpload: 'Videoupload fehlgeschlagen, bitte versuchen Sie es erneut',
        failedAudioUpload: 'Audioupload fehlgeschlagen, bitte versuchen Sie es erneut',
        failedTranslation: 'Übersetzung fehlgeschlagen, bitte versuchen Sie es erneut',
        failedGetResult: 'Ergebnis konnte nicht abgerufen werden',
        failedSubmit: 'Übermittlung fehlgeschlagen',
        failedFaceSwap: 'Gesichtstausch fehlgeschlagen, bitte versuchen Sie es erneut',
        failedLipSync: 'Lippensynchronisation fehlgeschlagen, bitte versuchen Sie es erneut',
        failedWatermarkRemoval: 'Wasserzeichenentfernung fehlgeschlagen, bitte versuchen Sie es erneut',
        failedAudioGeneration: 'Audiogenerierung fehlgeschlagen, bitte versuchen Sie es erneut',
        failedAudioDownload: 'Audio-Download fehlgeschlagen, bitte versuchen Sie es erneut',
        failedImageDownload: 'Bild-Download fehlgeschlagen, bitte versuchen Sie es erneut',
        failedVideoDownload: 'Video-Download fehlgeschlagen, bitte versuchen Sie es erneut',
        failedWithReason: 'Fehlgeschlagen: ',
        errorUploadVideoAndStyle: 'Bitte laden Sie ein Video hoch und wählen Sie einen Stil',
        successVideoToAnimeComplete: 'Video-zu-Anime-Konvertierung abgeschlossen!',
        failedVideoToAnime: 'Video-zu-Anime-Konvertierung fehlgeschlagen',
    },
    ru: {
        errorUnsupportedImageFormat: 'Пожалуйста, загрузите поддерживаемые форматы изображений (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'Размер файла изображения не может превышать 10 МБ',
        errorUnsupportedVideoFormat: 'Пожалуйста, загрузите поддерживаемые форматы видео',
        errorVideoSizeExceeded: 'Размер видеофайла не может превышать 500 МБ',
        errorVideoSizeExceededCustom: 'Размер видеофайла не может превышать {size}МБ',
        errorUnsupportedAudioFormat: 'Пожалуйста, загрузите поддерживаемые форматы аудио',
        errorAudioSizeExceeded: 'Размер аудиофайла не может превышать 50 МБ',
        errorEnterVideoLink: 'Пожалуйста, введите ссылку на видео',
        errorInvalidVideoLink: 'Пожалуйста, введите действительную ссылку на видео',
        errorUploadVideoFirst: 'Пожалуйста, сначала загрузите видео',
        errorUploadVideoAndAudio: 'Пожалуйста, сначала загрузите видео и аудио',
        errorUploadVideoAndFace: 'Пожалуйста, сначала загрузите видео и целевое лицо',
        errorSelectVoiceAndText: 'Пожалуйста, выберите голос и введите текст',
        errorSelectWatermarkArea: 'Пожалуйста, сначала выберите область водяного знака',
        errorUploadVideoOrLink: 'Пожалуйста, загрузите видео или введите ссылку на видео',
        errorGetVoiceList: 'Не удалось получить список голосов',
        errorNoPreviewAudio: 'У этого голоса нет аудио предпросмотра',
        errorPlayFailed: 'Воспроизведение не удалось, попробуйте снова',
        errorVoicePreviewFailed: 'Не удалось воспроизвести предпросмотр голоса',
        errorUploadVideoAndPrompt: 'Пожалуйста, сначала загрузите видео и введите подсказку',
        errorVideoDurationTooShort: 'Продолжительность видео должна быть больше 2 секунд',
        errorVideoDurationTooLong: 'Продолжительность видео не может превышать 30 секунд',
        errorOutputResolutionTooLow: 'Выходное разрешение не может быть ниже разрешения исходного видео',
        errorOutputResolutionAutoAdjusted: 'Выходное разрешение было автоматически изменено на {resolution}',
        successImageUploaded: 'Изображение успешно загружено',
        successVideoUploaded: 'Видео успешно загружено',
        successAudioUploaded: 'Аудио успешно загружено',
        successTranslationComplete: 'Перевод завершён!',
        successVideoLinkAdded: 'Ссылка на видео успешно добавлена',
        successSelectionSaved: 'Выделение успешно сохранено',
        successAudioGenerated: 'Аудио успешно сгенерировано!',
        successAudioDownloaded: 'Аудио успешно скачано',
        successFaceSwapComplete: 'Замена лица завершена!',
        successLipSyncComplete: 'Синхронизация губ завершена!',
        successWatermarkRemovalComplete: 'Начато удаление водяного знака с видео',
        successImageDownloaded: 'Изображение успешно скачано',
        successVideoDownloaded: 'Видео успешно скачано',
        warningImageUploading: 'Загрузка изображения, пожалуйста, подождите...',
        warningFileUploading: 'Загрузка файла, пожалуйста, подождите...',
        warningNoResult: 'Результат перевода не получен',
        warningNoResultVideo: 'Результирующее видео не получено',
        warningSelectionExists: 'Это выделение уже существует',
        warningNoAudioUrl: 'URL аудио не получен',
        infoStartTranslation: 'Начинается обработка перевода...',
        infoStartWatermarkRemoval: 'Начинается удаление водяного знака...',
        infoStartFaceSwap: 'Начинается замена лица...',
        infoStartLipSync: 'Начинается синхронизация губ...',
        infoGeneratingAudio: 'Генерация аудио...',
        failedUpload: 'Загрузка не удалась, попробуйте снова',
        failedImageUpload: 'Загрузка изображения не удалась, попробуйте снова',
        failedVideoUpload: 'Загрузка видео не удалась, попробуйте снова',
        failedAudioUpload: 'Загрузка аудио не удалась, попробуйте снова',
        failedTranslation: 'Перевод не удался, попробуйте снова',
        failedGetResult: 'Не удалось получить результат',
        failedSubmit: 'Отправка не удалась',
        failedFaceSwap: 'Замена лица не удалась, попробуйте снова',
        failedLipSync: 'Синхронизация губ не удалась, попробуйте снова',
        failedWatermarkRemoval: 'Удаление водяного знака не удалось, попробуйте снова',
        failedAudioGeneration: 'Генерация аудио не удалась, попробуйте снова',
        failedAudioDownload: 'Скачивание аудио не удалось, попробуйте снова',
        failedImageDownload: 'Скачивание изображения не удалось, попробуйте снова',
        failedVideoDownload: 'Скачивание видео не удалось, попробуйте снова',
        failedWithReason: 'Ошибка: ',
        errorUploadVideoAndStyle: 'Пожалуйста, загрузите видео и выберите стиль',
        successVideoToAnimeComplete: 'Конвертация видео в аниме завершена!',
        failedVideoToAnime: 'Конвертация видео в аниме не удалась',
    },
    pt: {
        errorUnsupportedImageFormat: 'Por favor, envie formatos de imagem suportados (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'O arquivo de imagem não pode exceder 10MB',
        errorUnsupportedVideoFormat: 'Por favor, envie formatos de vídeo suportados',
        errorVideoSizeExceeded: 'O arquivo de vídeo não pode exceder 500MB',
        errorVideoSizeExceededCustom: 'O arquivo de vídeo não pode exceder {size}MB',
        errorUnsupportedAudioFormat: 'Por favor, envie formatos de áudio suportados',
        errorAudioSizeExceeded: 'O arquivo de áudio não pode exceder 50MB',
        errorEnterVideoLink: 'Por favor, insira o link do vídeo',
        errorInvalidVideoLink: 'Por favor, insira um link de vídeo válido',
        errorUploadVideoFirst: 'Por favor, envie o vídeo primeiro',
        errorUploadVideoAndAudio: 'Por favor, envie o vídeo e o áudio primeiro',
        errorUploadVideoAndFace: 'Por favor, envie o vídeo e o rosto alvo primeiro',
        errorSelectVoiceAndText: 'Por favor, selecione a voz e insira o texto',
        errorSelectWatermarkArea: `Por favor, selecione a área da marca d'água primeiro`,
        errorUploadVideoOrLink: 'Por favor, envie o vídeo ou insira o link do vídeo',
        errorGetVoiceList: 'Falha ao obter a lista de vozes',
        errorNoPreviewAudio: 'Esta voz não tem áudio de pré-visualização',
        errorPlayFailed: 'Falha na reprodução, tente novamente',
        errorVoicePreviewFailed: 'Falha na reprodução da pré-visualização da voz',
        errorUploadVideoAndPrompt: 'Por favor, envie o vídeo e insira o prompt primeiro',
        errorVideoDurationTooShort: 'A duração do vídeo deve ser maior que 2 segundos',
        errorVideoDurationTooLong: 'A duração do vídeo não pode exceder 30 segundos',
        errorOutputResolutionTooLow: 'A resolução de saída não pode ser inferior à resolução do vídeo original',
        errorOutputResolutionAutoAdjusted: 'A resolução de saída foi ajustada automaticamente para {resolution}',
        successImageUploaded: 'Imagem enviada com sucesso',
        successVideoUploaded: 'Vídeo enviado com sucesso',
        successAudioUploaded: 'Áudio enviado com sucesso',
        successTranslationComplete: 'Tradução concluída!',
        successVideoLinkAdded: 'Link do vídeo adicionado com sucesso',
        successSelectionSaved: 'Seleção salva com sucesso',
        successAudioGenerated: 'Áudio gerado com sucesso!',
        successAudioDownloaded: 'Áudio baixado com sucesso',
        successFaceSwapComplete: 'Troca de rosto concluída!',
        successLipSyncComplete: 'Sincronização labial concluída!',
        successWatermarkRemovalComplete: `Iniciando remoção de marca d'água do vídeo`,
        successImageDownloaded: 'Imagem baixada com sucesso',
        successVideoDownloaded: 'Vídeo baixado com sucesso',
        warningImageUploading: 'Enviando imagem, por favor aguarde...',
        warningFileUploading: 'Enviando arquivo, por favor aguarde...',
        warningNoResult: 'Nenhum resultado de tradução obtido',
        warningNoResultVideo: 'Nenhum vídeo de resultado obtido',
        warningSelectionExists: 'Esta seleção já existe',
        warningNoAudioUrl: 'URL de áudio não obtida',
        infoStartTranslation: 'Iniciando processamento de tradução...',
        infoStartWatermarkRemoval: `Iniciando remoção de marca d'água...`,
        infoStartFaceSwap: 'Iniciando troca de rosto...',
        infoStartLipSync: 'Iniciando sincronização labial...',
        infoGeneratingAudio: 'Gerando áudio...',
        failedUpload: 'Falha no envio, tente novamente',
        failedImageUpload: 'Falha no envio da imagem, tente novamente',
        failedVideoUpload: 'Falha no envio do vídeo, tente novamente',
        failedAudioUpload: 'Falha no envio do áudio, tente novamente',
        failedTranslation: 'Falha na tradução, tente novamente',
        failedGetResult: 'Falha ao obter resultado',
        failedSubmit: 'Falha ao enviar',
        failedFaceSwap: 'Falha na troca de rosto, tente novamente',
        failedLipSync: 'Falha na sincronização labial, tente novamente',
        failedWatermarkRemoval: `Falha na remoção de marca d'água, tente novamente`,
        failedAudioGeneration: 'Falha na geração de áudio, tente novamente',
        failedAudioDownload: 'Falha no download do áudio, tente novamente',
        failedImageDownload: 'Falha no download da imagem, tente novamente',
        failedVideoDownload: 'Falha no download do vídeo, tente novamente',
        failedWithReason: 'Falha: ',
        errorUploadVideoAndStyle: 'Por favor, carregue um vídeo e selecione um estilo',
        successVideoToAnimeComplete: 'Conversão de vídeo para anime concluída!',
        failedVideoToAnime: 'Falha na conversão de vídeo para anime',
    },
    it: {
        errorUnsupportedImageFormat: 'Carica formati immagine supportati (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'Il file immagine non può superare 10MB',
        errorUnsupportedVideoFormat: 'Carica formati video supportati',
        errorVideoSizeExceeded: 'Il file video non può superare 500MB',
        errorVideoSizeExceededCustom: 'Il file video non può superare {size}MB',
        errorUnsupportedAudioFormat: 'Carica formati audio supportati',
        errorAudioSizeExceeded: 'Il file audio non può superare 50MB',
        errorEnterVideoLink: 'Inserisci il link del video',
        errorInvalidVideoLink: 'Inserisci un link video valido',
        errorUploadVideoFirst: 'Carica prima il video',
        errorUploadVideoAndAudio: `Carica prima il video e l'audio`,
        errorUploadVideoAndFace: 'Carica prima il video e il viso di destinazione',
        errorSelectVoiceAndText: 'Seleziona una voce e inserisci il testo',
        errorSelectWatermarkArea: `Seleziona prima l'area della filigrana`,
        errorUploadVideoOrLink: 'Carica il video o inserisci il link del video',
        errorGetVoiceList: `Impossibile ottenere l'elenco delle voci`,
        errorNoPreviewAudio: 'Questa voce non ha audio di anteprima',
        errorPlayFailed: 'Riproduzione fallita, riprova',
        errorVoicePreviewFailed: 'Riproduzione anteprima voce fallita',
        errorUploadVideoAndPrompt: 'Carica prima il video e inserisci il prompt',
        errorVideoDurationTooShort: 'La durata del video deve essere superiore a 2 secondi',
        errorVideoDurationTooLong: 'La durata del video non può superare i 30 secondi',
        errorOutputResolutionTooLow: 'La risoluzione di output non può essere inferiore a quella del video originale',
        errorOutputResolutionAutoAdjusted: 'La risoluzione di output è stata regolata automaticamente su {resolution}',
        successImageUploaded: 'Immagine caricata con successo',
        successVideoUploaded: 'Video caricato con successo',
        successAudioUploaded: 'Audio caricato con successo',
        successTranslationComplete: 'Traduzione completata!',
        successVideoLinkAdded: 'Link video aggiunto con successo',
        successSelectionSaved: 'Selezione salvata con successo',
        successAudioGenerated: 'Audio generato con successo!',
        successAudioDownloaded: 'Audio scaricato con successo',
        successFaceSwapComplete: 'Scambio volto completato!',
        successLipSyncComplete: 'Sincronizzazione labiale completata!',
        successWatermarkRemovalComplete: 'Avvio rimozione filigrana video',
        successImageDownloaded: 'Immagine scaricata con successo',
        successVideoDownloaded: 'Video scaricato con successo',
        warningImageUploading: 'Caricamento immagine, attendere prego...',
        warningFileUploading: 'Caricamento file, attendere prego...',
        warningNoResult: 'Nessun risultato di traduzione ottenuto',
        warningNoResultVideo: 'Nessun video risultato ottenuto',
        warningSelectionExists: 'Questa selezione esiste già',
        warningNoAudioUrl: 'URL audio non ottenuto',
        infoStartTranslation: 'Avvio elaborazione traduzione...',
        infoStartWatermarkRemoval: 'Avvio rimozione filigrana...',
        infoStartFaceSwap: 'Avvio scambio volto...',
        infoStartLipSync: 'Avvio sincronizzazione labiale...',
        infoGeneratingAudio: 'Generazione audio in corso...',
        failedUpload: 'Caricamento fallito, riprova',
        failedImageUpload: 'Caricamento immagine fallito, riprova',
        failedVideoUpload: 'Caricamento video fallito, riprova',
        failedAudioUpload: 'Caricamento audio fallito, riprova',
        failedTranslation: 'Traduzione fallita, riprova',
        failedGetResult: 'Impossibile ottenere il risultato',
        failedSubmit: 'Invio fallito',
        failedFaceSwap: 'Scambio volto fallito, riprova',
        failedLipSync: 'Sincronizzazione labiale fallita, riprova',
        failedWatermarkRemoval: 'Rimozione filigrana fallita, riprova',
        failedAudioGeneration: 'Generazione audio fallita, riprova',
        failedAudioDownload: 'Download audio fallito, riprova',
        failedImageDownload: 'Download immagine fallito, riprova',
        failedVideoDownload: 'Download video fallito, riprova',
        failedWithReason: 'Errore: ',
        errorUploadVideoAndStyle: 'Carica un video e seleziona uno stile',
        successVideoToAnimeComplete: 'Conversione video ad anime completata!',
        failedVideoToAnime: 'Conversione video ad anime fallita',
    },
    ar: {
        errorUnsupportedImageFormat: 'يرجى تحميل تنسيقات الصور المدعومة (JPEG، PNG، WEBP)',
        errorImageSizeExceeded: 'لا يمكن أن يتجاوز حجم ملف الصورة 10 ميجابايت',
        errorUnsupportedVideoFormat: 'يرجى تحميل تنسيقات الفيديو المدعومة',
        errorVideoSizeExceeded: 'لا يمكن أن يتجاوز حجم ملف الفيديو 500 ميجابايت',
        errorVideoSizeExceededCustom: 'لا يمكن أن يتجاوز ملف الفيديو {size} ميجابايت',
        errorUnsupportedAudioFormat: 'يرجى تحميل تنسيقات الصوت المدعومة',
        errorAudioSizeExceeded: 'لا يمكن أن يتجاوز حجم ملف الصوت 50 ميجابايت',
        errorEnterVideoLink: 'يرجى إدخال رابط الفيديو',
        errorInvalidVideoLink: 'يرجى إدخال رابط فيديو صالح',
        errorUploadVideoFirst: 'يرجى تحميل الفيديو أولاً',
        errorUploadVideoAndAudio: 'يرجى تحميل الفيديو والصوت أولاً',
        errorUploadVideoAndFace: 'يرجى تحميل الفيديو والوجه المستهدف أولاً',
        errorSelectVoiceAndText: 'يرجى اختيار الصوت وإدخال النص',
        errorSelectWatermarkArea: 'يرجى تحديد منطقة العلامة المائية أولاً',
        errorUploadVideoOrLink: 'يرجى تحميل الفيديو أو إدخال رابط الفيديو',
        errorGetVoiceList: 'فشل في الحصول على قائمة الأصوات',
        errorNoPreviewAudio: 'هذا الصوت ليس له معاينة صوتية',
        errorPlayFailed: 'فشل التشغيل، يرجى المحاولة مرة أخرى',
        errorVoicePreviewFailed: 'فشل تشغيل معاينة الصوت',
        errorUploadVideoAndPrompt: 'يرجى تحميل الفيديو وإدخال التعليمات أولاً',
        errorVideoDurationTooShort: 'يجب أن تكون مدة الفيديو أكثر من ثانيتين',
        errorVideoDurationTooLong: 'لا يمكن أن تتجاوز مدة الفيديو 30 ثانية',
        errorOutputResolutionTooLow: 'لا يمكن أن تكون دقة الإخراج أقل من دقة الفيديو الأصلي',
        errorOutputResolutionAutoAdjusted: 'تم ضبط دقة الإخراج تلقائيًا إلى {resolution}',
        successImageUploaded: 'تم رفع الصورة بنجاح',
        successVideoUploaded: 'تم رفع الفيديو بنجاح',
        successAudioUploaded: 'تم رفع الصوت بنجاح',
        successTranslationComplete: 'اكتملت الترجمة!',
        successVideoLinkAdded: 'تمت إضافة رابط الفيديو بنجاح',
        successSelectionSaved: 'تم حفظ التحديد بنجاح',
        successAudioGenerated: 'تم إنشاء الصوت بنجاح!',
        successAudioDownloaded: 'تم تنزيل الصوت بنجاح',
        successFaceSwapComplete: 'اكتمل تبديل الوجه!',
        successLipSyncComplete: 'اكتملت مزامنة الشفاه!',
        successWatermarkRemovalComplete: 'بدء إزالة العلامة المائية من الفيديو',
        successImageDownloaded: 'تم تنزيل الصورة بنجاح',
        successVideoDownloaded: 'تم تنزيل الفيديو بنجاح',
        warningImageUploading: 'جارٍ رفع الصورة، يرجى الانتظار...',
        warningFileUploading: 'جارٍ رفع الملف، يرجى الانتظار...',
        warningNoResult: 'لم يتم الحصول على نتيجة الترجمة',
        warningNoResultVideo: 'لم يتم الحصول على فيديو النتيجة',
        warningSelectionExists: 'هذا التحديد موجود بالفعل',
        warningNoAudioUrl: 'لم يتم الحصول على رابط الصوت',
        infoStartTranslation: 'جارٍ بدء معالجة الترجمة...',
        infoStartWatermarkRemoval: 'جارٍ بدء إزالة العلامة المائية...',
        infoStartFaceSwap: 'جارٍ بدء تبديل الوجه...',
        infoStartLipSync: 'جارٍ بدء مزامنة الشفاه...',
        infoGeneratingAudio: 'جارٍ إنشاء الصوت...',
        failedUpload: 'فشل الرفع، يرجى المحاولة مرة أخرى',
        failedImageUpload: 'فشل رفع الصورة، يرجى المحاولة مرة أخرى',
        failedVideoUpload: 'فشل رفع الفيديو، يرجى المحاولة مرة أخرى',
        failedAudioUpload: 'فشل رفع الصوت، يرجى المحاولة مرة أخرى',
        failedTranslation: 'فشلت الترجمة، يرجى المحاولة مرة أخرى',
        failedGetResult: 'فشل في الحصول على النتيجة',
        failedSubmit: 'فشل الإرسال',
        failedFaceSwap: 'فشل تبديل الوجه، يرجى المحاولة مرة أخرى',
        failedLipSync: 'فشلت مزامنة الشفاه، يرجى المحاولة مرة أخرى',
        failedWatermarkRemoval: 'فشلت إزالة العلامة المائية، يرجى المحاولة مرة أخرى',
        failedAudioGeneration: 'فشل إنشاء الصوت، يرجى المحاولة مرة أخرى',
        failedAudioDownload: 'فشل تنزيل الصوت، يرجى المحاولة مرة أخرى',
        failedImageDownload: 'فشل تنزيل الصورة، يرجى المحاولة مرة أخرى',
        failedVideoDownload: 'فشل تنزيل الفيديو، يرجى المحاولة مرة أخرى',
        failedWithReason: 'فشل: ',
        errorUploadVideoAndStyle: 'يرجى تحميل فيديو واختيار نمط',
        successVideoToAnimeComplete: 'اكتمل تحويل الفيديو إلى أنمي!',
        failedVideoToAnime: 'فشل تحويل الفيديو إلى أنمي',
    },
    th: {
        errorUnsupportedImageFormat: 'กรุณาอัปโหลดรูปแบบภาพที่รองรับ (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'ไฟล์ภาพต้องไม่เกิน 10MB',
        errorUnsupportedVideoFormat: 'กรุณาอัปโหลดรูปแบบวิดีโอที่รองรับ',
        errorVideoSizeExceeded: 'ไฟล์วิดีโอต้องไม่เกิน 500MB',
        errorVideoSizeExceededCustom: 'ไฟล์วิดีโอต้องไม่เกิน {size}MB',
        errorUnsupportedAudioFormat: 'กรุณาอัปโหลดรูปแบบเสียงที่รองรับ',
        errorAudioSizeExceeded: 'ไฟล์เสียงต้องไม่เกิน 50MB',
        errorEnterVideoLink: 'กรุณาใส่ลิงก์วิดีโอ',
        errorInvalidVideoLink: 'กรุณาใส่ลิงก์วิดีโอที่ถูกต้อง',
        errorUploadVideoFirst: 'กรุณาอัปโหลดวิดีโอก่อน',
        errorUploadVideoAndAudio: 'กรุณาอัปโหลดวิดีโอและเสียงก่อน',
        errorUploadVideoAndFace: 'กรุณาอัปโหลดวิดีโอและใบหน้าเป้าหมายก่อน',
        errorSelectVoiceAndText: 'กรุณาเลือกเสียงและใส่ข้อความ',
        errorSelectWatermarkArea: 'กรุณาเลือกพื้นที่ลายน้ำก่อน',
        errorUploadVideoOrLink: 'กรุณาอัปโหลดวิดีโอหรือใส่ลิงก์วิดีโอก่อน',
        errorGetVoiceList: 'ไม่สามารถดึงรายการเสียงได้',
        errorNoPreviewAudio: 'เสียงนี้ไม่มีเสียงตัวอย่าง',
        errorPlayFailed: 'เล่นไม่สำเร็จ กรุณาลองอีกครั้ง',
        errorVoicePreviewFailed: 'เล่นตัวอย่างเสียงไม่สำเร็จ',
        errorUploadVideoAndPrompt: 'กรุณาอัปโหลดวิดีโอและใส่พรอมต์ก่อน',
        errorVideoDurationTooShort: 'ความยาววิดีโอต้องมากกว่า 2 วินาที',
        errorVideoDurationTooLong: 'ความยาววิดีโอต้องไม่เกิน 30 วินาที',
        errorOutputResolutionTooLow: 'ความละเอียดเอาต์พุตต้องไม่ต่ำกว่าความละเอียดวิดีโอต้นฉบับ',
        errorOutputResolutionAutoAdjusted: 'ความละเอียดเอาต์พุตถูกปรับอัตโนมัติเป็น {resolution}',
        successImageUploaded: 'อัปโหลดรูปภาพสำเร็จ',
        successVideoUploaded: 'อัปโหลดวิดีโอสำเร็จ',
        successAudioUploaded: 'อัปโหลดเสียงสำเร็จ',
        successTranslationComplete: 'แปลเสร็จสิ้น!',
        successVideoLinkAdded: 'เพิ่มลิงก์วิดีโอสำเร็จ',
        successSelectionSaved: 'บันทึกการเลือกสำเร็จ',
        successAudioGenerated: 'สร้างเสียงสำเร็จ!',
        successAudioDownloaded: 'ดาวน์โหลดเสียงสำเร็จ',
        successFaceSwapComplete: 'สลับหน้าเสร็จสิ้น!',
        successLipSyncComplete: 'ซิงค์ปากเสร็จสิ้น!',
        successWatermarkRemovalComplete: 'เริ่มลบลายน้ำวิดีโอ',
        successImageDownloaded: 'ดาวน์โหลดรูปภาพสำเร็จ',
        successVideoDownloaded: 'ดาวน์โหลดวิดีโอสำเร็จ',
        warningImageUploading: 'กำลังอัปโหลดรูปภาพ กรุณารอสักครู่...',
        warningFileUploading: 'กำลังอัปโหลดไฟล์ กรุณารอสักครู่...',
        warningNoResult: 'ไม่ได้รับผลการแปล',
        warningNoResultVideo: 'ไม่ได้รับวิดีโอผลลัพธ์',
        warningSelectionExists: 'การเลือกนี้มีอยู่แล้ว',
        warningNoAudioUrl: 'ไม่ได้รับ URL เสียง',
        infoStartTranslation: 'กำลังเริ่มการประมวลผลการแปล...',
        infoStartWatermarkRemoval: 'กำลังเริ่มลบลายน้ำ...',
        infoStartFaceSwap: 'กำลังเริ่มสลับหน้า...',
        infoStartLipSync: 'กำลังเริ่มซิงค์ปาก...',
        infoGeneratingAudio: 'กำลังสร้างเสียง...',
        failedUpload: 'อัปโหลดล้มเหลว กรุณาลองอีกครั้ง',
        failedImageUpload: 'อัปโหลดรูปภาพล้มเหลว กรุณาลองอีกครั้ง',
        failedVideoUpload: 'อัปโหลดวิดีโอล้มเหลว กรุณาลองอีกครั้ง',
        failedAudioUpload: 'อัปโหลดเสียงล้มเหลว กรุณาลองอีกครั้ง',
        failedTranslation: 'การแปลล้มเหลว กรุณาลองอีกครั้ง',
        failedGetResult: 'ไม่สามารถรับผลลัพธ์',
        failedSubmit: 'ส่งล้มเหลว',
        failedFaceSwap: 'สลับหน้าล้มเหลว กรุณาลองอีกครั้ง',
        failedLipSync: 'ซิงค์ปากล้มเหลว กรุณาลองอีกครั้ง',
        failedWatermarkRemoval: 'ลบลายน้ำล้มเหลว กรุณาลองอีกครั้ง',
        failedAudioGeneration: 'สร้างเสียงล้มเหลว กรุณาลองอีกครั้ง',
        failedAudioDownload: 'ดาวน์โหลดเสียงล้มเหลว กรุณาลองอีกครั้ง',
        failedImageDownload: 'ดาวน์โหลดรูปภาพล้มเหลว กรุณาลองอีกครั้ง',
        failedVideoDownload: 'ดาวน์โหลดวิดีโอล้มเหลว กรุณาลองอีกครั้ง',
        failedWithReason: 'ล้มเหลว: ',
        errorUploadVideoAndStyle: 'Upload venligst video og vælg stil',
        successVideoToAnimeComplete: 'Video-animekonvertering fuldført!',
        failedVideoToAnime: 'Video-animekonvertering mislykkedes',
    },
    da: {
        errorUnsupportedImageFormat: 'Upload venligst understøttede billedformater (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'Billedfilen må ikke overstige 10MB',
        errorUnsupportedVideoFormat: 'Upload venligst understøttede videoformater',
        errorVideoSizeExceeded: 'Videofil må ikke overstige 500MB',
        errorVideoSizeExceededCustom: 'Videofil må ikke overstige {size}MB',
        errorUnsupportedAudioFormat: 'Upload venligst understøttede lydformater',
        errorAudioSizeExceeded: 'Lydfil må ikke overstige 50MB',
        errorEnterVideoLink: 'Indtast venligst videolink',
        errorInvalidVideoLink: 'Indtast venligst et gyldigt videolink',
        errorUploadVideoFirst: 'Upload venligst video først',
        errorUploadVideoAndAudio: 'Upload venligst video og lyd først',
        errorUploadVideoAndFace: 'Upload venligst video og målansigt først',
        errorSelectVoiceAndText: 'Vælg venligst stemme og indtast tekst',
        errorSelectWatermarkArea: 'Vælg venligst vandmærkeområdet først',
        errorUploadVideoOrLink: 'Upload venligst video eller indtast videolink først',
        errorGetVoiceList: 'Kunne ikke hente stemmeliste',
        errorNoPreviewAudio: 'Denne stemme har ingen forhåndslyd',
        errorPlayFailed: 'Afspilning mislykkedes, prøv igen',
        errorVoicePreviewFailed: 'Afspilning af stemmeforhåndsvisning mislykkedes',
        errorUploadVideoAndPrompt: 'Upload venligst video og indtast prompt først',
        errorVideoDurationTooShort: 'Videolængden skal være over 2 sekunder',
        errorVideoDurationTooLong: 'Videolængden må ikke overstige 30 sekunder',
        errorOutputResolutionTooLow: 'Outputopløsning må ikke være lavere end kildevideoens opløsning',
        errorOutputResolutionAutoAdjusted: 'Outputopløsning er automatisk justeret til {resolution}',
        successImageUploaded: 'Billedet er uploadet',
        successVideoUploaded: 'Videoen er uploadet',
        successAudioUploaded: 'Lyden er uploadet',
        successTranslationComplete: 'Oversættelse fuldført!',
        successVideoLinkAdded: 'Videolink tilføjet',
        successSelectionSaved: 'Valg gemt',
        successAudioGenerated: 'Lyd genereret!',
        successAudioDownloaded: 'Lyd downloadet',
        successFaceSwapComplete: 'Ansigtsbytte fuldført!',
        successLipSyncComplete: 'Læbesynk fuldført!',
        successWatermarkRemovalComplete: 'Starter fjernelse af vandmærke',
        successImageDownloaded: 'Billede downloadet',
        successVideoDownloaded: 'Video downloadet',
        warningImageUploading: 'Billedet uploades, vent venligst...',
        warningFileUploading: 'Filen uploades, vent venligst...',
        warningNoResult: 'Ingen oversættelsesresultat fundet',
        warningNoResultVideo: 'Intet resultatvideo fundet',
        warningSelectionExists: 'Dette valg findes allerede',
        warningNoAudioUrl: 'Ingen lyd-URL fundet',
        infoStartTranslation: 'Starter oversættelse...',
        infoStartWatermarkRemoval: 'Starter fjernelse af vandmærke...',
        infoStartFaceSwap: 'Starter ansigtsbytte...',
        infoStartLipSync: 'Starter læbesynk...',
        infoGeneratingAudio: 'Genererer lyd...',
        failedUpload: 'Upload mislykkedes, prøv igen',
        failedImageUpload: 'Billedupload mislykkedes, prøv igen',
        failedVideoUpload: 'Videoupload mislykkedes, prøv igen',
        failedAudioUpload: 'Lydupload mislykkedes, prøv igen',
        failedTranslation: 'Oversættelse mislykkedes, prøv igen',
        failedGetResult: 'Kunne ikke hente resultat',
        failedSubmit: 'Indsendelse mislykkedes',
        failedFaceSwap: 'Ansigtsbytte mislykkedes, prøv igen',
        failedLipSync: 'Læbesynk mislykkedes, prøv igen',
        failedWatermarkRemoval: 'Fjernelse af vandmærke mislykkedes, prøv igen',
        failedAudioGeneration: 'Lydgenerering mislykkedes, prøv igen',
        failedAudioDownload: 'Lyddownload mislykkedes, prøv igen',
        failedImageDownload: 'Billeddownload mislykkedes, prøv igen',
        failedVideoDownload: 'Videodownload mislykkedes, prøv igen',
        failedWithReason: 'Mislykkedes: ',
        errorUploadVideoAndStyle: 'Upload venligst video og vælg stil',
        successVideoToAnimeComplete: 'Video-animekonvertering fuldført!',
        failedVideoToAnime: 'Video-animekonvertering mislykkedes',
    },
    no: {
        errorUnsupportedImageFormat: 'Vennligst last opp støttede bildeformater (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'Bildefilen kan ikke overstige 10MB',
        errorUnsupportedVideoFormat: 'Vennligst last opp støttede videoformater',
        errorVideoSizeExceeded: 'Videofilen kan ikke overstige 500MB',
        errorVideoSizeExceededCustom: 'Videofilen kan ikke overstige {size}MB',
        errorUnsupportedAudioFormat: 'Vennligst last opp støttede lydformater',
        errorAudioSizeExceeded: 'Lydfilen kan ikke overstige 50MB',
        errorEnterVideoLink: 'Vennligst skriv inn videolenke',
        errorInvalidVideoLink: 'Vennligst skriv inn en gyldig videolenke',
        errorUploadVideoFirst: 'Vennligst last opp video først',
        errorUploadVideoAndAudio: 'Vennligst last opp video og lyd først',
        errorUploadVideoAndFace: 'Vennligst last opp video og målansikt først',
        errorSelectVoiceAndText: 'Vennligst velg stemme og skriv inn tekst',
        errorSelectWatermarkArea: 'Vennligst velg vannmerkeområdet først',
        errorUploadVideoOrLink: 'Vennligst last opp video eller skriv inn videolenke først',
        errorGetVoiceList: 'Kunne ikke hente stemmeliste',
        errorNoPreviewAudio: 'Denne stemmen har ingen forhåndsvisningslyd',
        errorPlayFailed: 'Avspilling mislyktes, prøv igjen',
        errorVoicePreviewFailed: 'Forhåndsvisning av stemme mislyktes',
        errorUploadVideoAndPrompt: 'Vennligst last opp video og skriv inn prompt først',
        errorVideoDurationTooShort: 'Videovarighet må være mer enn 2 sekunder',
        errorVideoDurationTooLong: 'Videovarighet kan ikke overstige 30 sekunder',
        errorOutputResolutionTooLow: 'Utgangsoppløsningen kan ikke være lavere enn kildeoppløsningen',
        errorOutputResolutionAutoAdjusted: 'Utgangsoppløsningen er justert automatisk til {resolution}',
        successImageUploaded: 'Bilde lastet opp vellykket',
        successVideoUploaded: 'Video lastet opp vellykket',
        successAudioUploaded: 'Lyd lastet opp vellykket',
        successTranslationComplete: 'Oversettelse fullført!',
        successVideoLinkAdded: 'Videolenke lagt til vellykket',
        successSelectionSaved: 'Valg lagret',
        successAudioGenerated: 'Lyd generert!',
        successAudioDownloaded: 'Lyd lastet ned vellykket',
        successFaceSwapComplete: 'Ansiktsbytte fullført!',
        successLipSyncComplete: 'Leppesynk fullført!',
        successWatermarkRemovalComplete: 'Starter fjerning av videovannmerke',
        successImageDownloaded: 'Bilde lastet ned vellykket',
        successVideoDownloaded: 'Video lastet ned vellykket',
        warningImageUploading: 'Bilde lastes opp, vennligst vent...',
        warningFileUploading: 'Fil lastes opp, vennligst vent...',
        warningNoResult: 'Ingen oversettelsesresultat mottatt',
        warningNoResultVideo: 'Ingen resultatvideo mottatt',
        warningSelectionExists: 'Dette valget finnes allerede',
        warningNoAudioUrl: 'Ingen lyd-URL mottatt',
        infoStartTranslation: 'Starter oversettelsesbehandling...',
        infoStartWatermarkRemoval: 'Starter behandling for vannmerkefjerning...',
        infoStartFaceSwap: 'Starter behandling for ansiktsbytte...',
        infoStartLipSync: 'Starter behandling for leppesynk...',
        infoGeneratingAudio: 'Genererer lyd...',
        failedUpload: 'Opplasting mislyktes, prøv igjen',
        failedImageUpload: 'Bildeopplasting mislyktes, prøv igjen',
        failedVideoUpload: 'Videoopplasting mislyktes, prøv igjen',
        failedAudioUpload: 'Lydoverføring mislyktes, prøv igjen',
        failedTranslation: 'Oversettelse mislyktes, prøv igjen',
        failedGetResult: 'Kunne ikke hente resultat',
        failedSubmit: 'Innsending mislyktes',
        failedFaceSwap: 'Ansiktsbytte mislyktes, prøv igjen',
        failedLipSync: 'Leppesynk mislyktes, prøv igjen',
        failedWatermarkRemoval: 'Vannmerkefjerning mislyktes, prøv igjen',
        failedAudioGeneration: 'Lydgenerering mislyktes, prøv igjen',
        failedAudioDownload: 'Lyddownload mislyktes, prøv igjen',
        failedImageDownload: 'Bilde nedlasting mislyktes, prøv igjen',
        failedVideoDownload: 'Videonedlasting mislyktes, prøv igjen',
        failedWithReason: 'Mislyktes: ',
        errorUploadVideoAndStyle: 'Vennligst last opp video og velg stil',
        successVideoToAnimeComplete: 'Video-til-anime-konvertering fullført!',
        failedVideoToAnime: 'Video-til-anime-konvertering mislyktes',
    },
    nl: {
        errorUnsupportedImageFormat: 'Upload ondersteunde afbeeldingsformaten (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'Afbeeldingsbestand mag niet groter zijn dan 10MB',
        errorUnsupportedVideoFormat: 'Upload ondersteunde videoformaten',
        errorVideoSizeExceeded: 'Videobestand mag niet groter zijn dan 500MB',
        errorVideoSizeExceededCustom: 'Videobestand mag niet groter zijn dan {size}MB',
        errorUnsupportedAudioFormat: 'Upload ondersteunde audioformaten',
        errorAudioSizeExceeded: 'Audiobestand mag niet groter zijn dan 50MB',
        errorEnterVideoLink: 'Voer een videolink in',
        errorInvalidVideoLink: 'Voer een geldige videolink in',
        errorUploadVideoFirst: 'Upload eerst een video',
        errorUploadVideoAndAudio: 'Upload eerst een video en audio',
        errorUploadVideoAndFace: 'Upload eerst een video en het doelgezicht',
        errorSelectVoiceAndText: 'Selecteer een stem en voer tekst in',
        errorSelectWatermarkArea: 'Selecteer eerst het watermerkgebied',
        errorUploadVideoOrLink: 'Upload eerst een video of voer een videolink in',
        errorGetVoiceList: 'Kon de stemmenlijst niet ophalen',
        errorNoPreviewAudio: 'Deze stem heeft geen preview-audio',
        errorPlayFailed: 'Afspelen mislukt, probeer het opnieuw',
        errorVoicePreviewFailed: 'Voorbeeldafspelen van stem mislukt',
        errorUploadVideoAndPrompt: 'Upload eerst een video en voer een prompt in',
        errorVideoDurationTooShort: 'Videoduur moet langer zijn dan 2 seconden',
        errorVideoDurationTooLong: 'Videoduur mag niet langer zijn dan 30 seconden',
        errorOutputResolutionTooLow: 'Uitvoerresolutie mag niet lager zijn dan de bronvideoresolutie',
        errorOutputResolutionAutoAdjusted: 'Uitvoerresolutie is automatisch aangepast naar {resolution}',
        successImageUploaded: 'Afbeelding succesvol geüpload',
        successVideoUploaded: 'Video succesvol geüpload',
        successAudioUploaded: 'Audio succesvol geüpload',
        successTranslationComplete: 'Vertaling voltooid!',
        successVideoLinkAdded: 'Videolink succesvol toegevoegd',
        successSelectionSaved: 'Selectie succesvol opgeslagen',
        successAudioGenerated: 'Audio succesvol gegenereerd!',
        successAudioDownloaded: 'Audio succesvol gedownload',
        successFaceSwapComplete: 'Gezichtsverwisseling voltooid!',
        successLipSyncComplete: 'Lipsync voltooid!',
        successWatermarkRemovalComplete: 'Starten met verwijderen van videowatermerk',
        successImageDownloaded: 'Afbeelding gedownload',
        successVideoDownloaded: 'Video gedownload',
        warningImageUploading: 'Afbeelding wordt geüpload, even geduld...',
        warningFileUploading: 'Bestand wordt geüpload, even geduld...',
        warningNoResult: 'Geen vertaalresultaat ontvangen',
        warningNoResultVideo: 'Geen resultaatvideo ontvangen',
        warningSelectionExists: 'Deze selectie bestaat al',
        warningNoAudioUrl: 'Geen audio-URL ontvangen',
        infoStartTranslation: 'Vertaalverwerking starten...',
        infoStartWatermarkRemoval: 'Watermerkverwijdering starten...',
        infoStartFaceSwap: 'Gezichtsverwisseling starten...',
        infoStartLipSync: 'Lipsync starten...',
        infoGeneratingAudio: 'Audio genereren...',
        failedUpload: 'Upload mislukt, probeer het opnieuw',
        failedImageUpload: 'Afbeeldingsupload mislukt, probeer het opnieuw',
        failedVideoUpload: 'Videoupload mislukt, probeer het opnieuw',
        failedAudioUpload: 'Audioupload mislukt, probeer het opnieuw',
        failedTranslation: 'Vertaling mislukt, probeer het opnieuw',
        failedGetResult: 'Kon resultaat niet ophalen',
        failedSubmit: 'Indienen mislukt',
        failedFaceSwap: 'Gezichtsverwisseling mislukt, probeer het opnieuw',
        failedLipSync: 'Lipsync mislukt, probeer het opnieuw',
        failedWatermarkRemoval: 'Watermerkverwijdering mislukt, probeer het opnieuw',
        failedAudioGeneration: 'Audio genereren mislukt, probeer het opnieuw',
        failedAudioDownload: 'Audio downloaden mislukt, probeer het opnieuw',
        failedImageDownload: 'Afbeelding downloaden mislukt, probeer het opnieuw',
        failedVideoDownload: 'Video downloaden mislukt, probeer het opnieuw',
        failedWithReason: 'Mislukt: ',
        errorUploadVideoAndStyle: 'Upload een video en selecteer een stijl',
        successVideoToAnimeComplete: 'Video-naar-anime-conversie voltooid!',
        failedVideoToAnime: 'Video-naar-anime-conversie mislukt',
    },
    id: {
        errorUnsupportedImageFormat: 'Silakan unggah format gambar yang didukung (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: 'File gambar tidak boleh melebihi 10MB',
        errorUnsupportedVideoFormat: 'Silakan unggah format video yang didukung',
        errorVideoSizeExceeded: 'File video tidak boleh melebihi 500MB',
        errorVideoSizeExceededCustom: 'File video tidak boleh melebihi {size}MB',
        errorUnsupportedAudioFormat: 'Silakan unggah format audio yang didukung',
        errorAudioSizeExceeded: 'File audio tidak boleh melebihi 50MB',
        errorEnterVideoLink: 'Silakan masukkan tautan video',
        errorInvalidVideoLink: 'Silakan masukkan tautan video yang valid',
        errorUploadVideoFirst: 'Silakan unggah video terlebih dahulu',
        errorUploadVideoAndAudio: 'Silakan unggah video dan audio terlebih dahulu',
        errorUploadVideoAndFace: 'Silakan unggah video dan wajah target terlebih dahulu',
        errorSelectVoiceAndText: 'Silakan pilih suara dan masukkan teks',
        errorSelectWatermarkArea: 'Silakan pilih area watermark terlebih dahulu',
        errorUploadVideoOrLink: 'Silakan unggah video atau masukkan tautan terlebih dahulu',
        errorGetVoiceList: 'Gagal mendapatkan daftar suara',
        errorNoPreviewAudio: 'Suara ini tidak memiliki audio pratinjau',
        errorPlayFailed: 'Pemutaran gagal, silakan coba lagi',
        errorVoicePreviewFailed: 'Pemutaran pratinjau suara gagal',
        errorUploadVideoAndPrompt: 'Silakan unggah video dan masukkan prompt terlebih dahulu',
        errorVideoDurationTooShort: 'Durasi video harus lebih dari 2 detik',
        errorVideoDurationTooLong: 'Durasi video tidak boleh melebihi 30 detik',
        errorOutputResolutionTooLow: 'Resolusi output tidak boleh lebih rendah dari resolusi video sumber',
        errorOutputResolutionAutoAdjusted: 'Resolusi output telah disesuaikan otomatis ke {resolution}',
        successImageUploaded: 'Gambar berhasil diunggah',
        successVideoUploaded: 'Video berhasil diunggah',
        successAudioUploaded: 'Audio berhasil diunggah',
        successTranslationComplete: 'Terjemahan selesai!',
        successVideoLinkAdded: 'Tautan video berhasil ditambahkan',
        successSelectionSaved: 'Pilihan berhasil disimpan',
        successAudioGenerated: 'Audio berhasil dihasilkan!',
        successAudioDownloaded: 'Audio berhasil diunduh',
        successFaceSwapComplete: 'Tukar wajah selesai!',
        successLipSyncComplete: 'Sinkronisasi bibir selesai!',
        successWatermarkRemovalComplete: 'Memulai penghapusan watermark video',
        successImageDownloaded: 'Gambar berhasil diunduh',
        successVideoDownloaded: 'Video berhasil diunduh',
        warningImageUploading: 'Mengunggah gambar, harap tunggu...',
        warningFileUploading: 'Mengunggah file, harap tunggu...',
        warningNoResult: 'Tidak ada hasil terjemahan',
        warningNoResultVideo: 'Tidak ada video hasil',
        warningSelectionExists: 'Pilihan ini sudah ada',
        warningNoAudioUrl: 'URL audio tidak ditemukan',
        infoStartTranslation: 'Mulai memproses terjemahan...',
        infoStartWatermarkRemoval: 'Mulai memproses penghapusan watermark...',
        infoStartFaceSwap: 'Mulai memproses tukar wajah...',
        infoStartLipSync: 'Mulai memproses sinkronisasi bibir...',
        infoGeneratingAudio: 'Sedang menghasilkan audio...',
        failedUpload: 'Gagal mengunggah, silakan coba lagi',
        failedImageUpload: 'Gagal mengunggah gambar, silakan coba lagi',
        failedVideoUpload: 'Gagal mengunggah video, silakan coba lagi',
        failedAudioUpload: 'Gagal mengunggah audio, silakan coba lagi',
        failedTranslation: 'Gagal menerjemahkan, silakan coba lagi',
        failedGetResult: 'Gagal mengambil hasil',
        failedSubmit: 'Gagal mengirim',
        failedFaceSwap: 'Gagal tukar wajah, silakan coba lagi',
        failedLipSync: 'Gagal sinkronisasi bibir, silakan coba lagi',
        failedWatermarkRemoval: 'Gagal menghapus watermark, silakan coba lagi',
        failedAudioGeneration: 'Gagal menghasilkan audio, silakan coba lagi',
        failedAudioDownload: 'Gagal mengunduh audio, silakan coba lagi',
        failedImageDownload: 'Gagal mengunduh gambar, silakan coba lagi',
        failedVideoDownload: 'Gagal mengunduh video, silakan coba lagi',
        failedWithReason: 'Gagal: ',
    },
    tr: {
        errorUnsupportedImageFormat: 'Lütfen desteklenen bir görsel formatı yükleyin (JPEG, PNG, WEBP)',
        errorImageSizeExceeded: `Görsel boyutu 10 MB'ı geçemez`,
        errorUnsupportedVideoFormat: 'Lütfen desteklenen bir video formatı yükleyin',
        errorVideoSizeExceeded: `Video boyutu 500 MB'ı geçemez`,
        errorVideoSizeExceededCustom: `Video boyutu {size} MB'ı geçemez`,
        errorUnsupportedAudioFormat: 'Lütfen desteklenen bir ses formatı yükleyin',
        errorAudioSizeExceeded: `Ses dosyası 50 MB'ı geçemez`,
        errorEnterVideoLink: 'Lütfen video bağlantısını girin',
        errorInvalidVideoLink: 'Lütfen geçerli bir video bağlantısı girin',
        errorUploadVideoFirst: 'Lütfen önce videoyu yükleyin',
        errorUploadVideoAndAudio: 'Lütfen önce videoyu ve sesi yükleyin',
        errorUploadVideoAndFace: 'Lütfen önce videoyu ve hedef yüzü yükleyin',
        errorSelectVoiceAndText: 'Lütfen bir ses seçin ve metin girin',
        errorSelectWatermarkArea: 'Lütfen önce filigran alanını seçin',
        errorUploadVideoOrLink: 'Lütfen önce video yükleyin veya bağlantı girin',
        errorGetVoiceList: 'Ses listesi alınamadı',
        errorNoPreviewAudio: 'Bu sesin önizleme sesi yok',
        errorPlayFailed: 'Oynatma başarısız, lütfen tekrar deneyin',
        errorVoicePreviewFailed: 'Ses önizlemesi oynatılamadı',
        errorUploadVideoAndPrompt: 'Lütfen önce video yükleyin ve komut girin',
        errorVideoDurationTooShort: 'Video süresi 2 saniyeden uzun olmalıdır',
        errorVideoDurationTooLong: 'Video süresi 30 saniyeyi geçemez',
        errorOutputResolutionTooLow: 'Çıktı çözünürlüğü kaynak video çözünürlüğünden düşük olamaz',
        errorOutputResolutionAutoAdjusted: 'Çıktı çözünürlüğü otomatik olarak {resolution} olarak ayarlandı',
        successImageUploaded: 'Görsel başarıyla yüklendi',
        successVideoUploaded: 'Video başarıyla yüklendi',
        successAudioUploaded: 'Ses başarıyla yüklendi',
        successTranslationComplete: 'Çeviri tamamlandı!',
        successVideoLinkAdded: 'Video bağlantısı başarıyla eklendi',
        successSelectionSaved: 'Seçim başarıyla kaydedildi',
        successAudioGenerated: 'Ses başarıyla oluşturuldu!',
        successAudioDownloaded: 'Ses başarıyla indirildi',
        successFaceSwapComplete: 'Yüz değiştirme tamamlandı!',
        successLipSyncComplete: 'Dudak senkronizasyonu tamamlandı!',
        successWatermarkRemovalComplete: 'Video filigran kaldırma başlatılıyor',
        successImageDownloaded: 'Görsel başarıyla indirildi',
        successVideoDownloaded: 'Video başarıyla indirildi',
        warningImageUploading: 'Görsel yükleniyor, lütfen bekleyin...',
        warningFileUploading: 'Dosya yükleniyor, lütfen bekleyin...',
        warningNoResult: 'Çeviri sonucu alınamadı',
        warningNoResultVideo: 'Sonuç videosu alınamadı',
        warningSelectionExists: 'Bu seçim zaten mevcut',
        warningNoAudioUrl: `Ses URL'si alınamadı`,
        infoStartTranslation: 'Çeviri işlemi başladı...',
        infoStartWatermarkRemoval: 'Filigran kaldırma işlemi başladı...',
        infoStartFaceSwap: 'Yüz değiştirme işlemi başladı...',
        infoStartLipSync: 'Dudak senkronizasyonu başladı...',
        infoGeneratingAudio: 'Ses oluşturuluyor...',
        failedUpload: 'Yükleme başarısız, lütfen tekrar deneyin',
        failedImageUpload: 'Görsel yükleme başarısız, lütfen tekrar deneyin',
        failedVideoUpload: 'Video yükleme başarısız, lütfen tekrar deneyin',
        failedAudioUpload: 'Ses yükleme başarısız, lütfen tekrar deneyin',
        failedTranslation: 'Çeviri başarısız, lütfen tekrar deneyin',
        failedGetResult: 'Sonuç alınamadı',
        failedSubmit: 'Gönderim başarısız',
        failedFaceSwap: 'Yüz değiştirme başarısız, lütfen tekrar deneyin',
        failedLipSync: 'Dudak senkronizasyonu başarısız, lütfen tekrar deneyin',
        failedWatermarkRemoval: 'Filigran kaldırma başarısız, lütfen tekrar deneyin',
        failedAudioGeneration: 'Ses oluşturma başarısız, lütfen tekrar deneyin',
        failedAudioDownload: 'Ses indirme başarısız, lütfen tekrar deneyin',
        failedImageDownload: 'Görsel indirme başarısız, lütfen tekrar deneyin',
        failedVideoDownload: 'Video indirme başarısız, lütfen tekrar deneyin',
        failedWithReason: 'Hata: ',
    },
}
